import { DbState, defaultDbState } from 'contexts/db-state';
import { createContext } from 'react';
import { DbOperation } from 'types';

export type LoggingContextData = {
    dbOperations: DbState<DbOperation>,
    isReady: () => boolean
    [key: string]: DbState<any> | (() => boolean)
}

export const defaultLoggingContextData: LoggingContextData = {
    dbOperations: defaultDbState<DbOperation>(),
    isReady: () => false
}

export const LoggingContext = createContext<LoggingContextData>(defaultLoggingContextData)